import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'mapfre-auditlib-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  constructor() { }

  @Input() visible;
  @Input() header: string = '';
  @Output() visibleChange = new EventEmitter();
  @Output() onHide = new EventEmitter();
  @Output() onShow= new EventEmitter();

  ngOnInit() {

  }

  onChange(event) {
    this.visible = event;
    this.visibleChange.emit(event);
  }


  onHideClicked(event){
    this.onHide.emit(event);
  }

  onShowClicked(event){
    this.onShow.emit(event);
  }
  

}
